import { Request, BaseApiUrl, getExportExcel } from "./api";

// 未完成列表
export const getWeighingInSaleOutListPage = (params) => {
  return Request.get(`${BaseApiUrl}/api/WeighingInSaleOut/get`, { params: params });
};
// 获取所有列表
export const getWeighingInSaleOutHistryListPage = (params) => {
  return Request.get(`${BaseApiUrl}/api/WeighingInSaleOut/Histry`, { params: params });
};

//获取磅秤信息
export const getWhsettingDetail = (params) => {
  return Request.get(`${BaseApiUrl}/api/Whsetting/GetWhsetting`, { params: params });
};
//新增
export const addWeighingInSaleOut = (params) => {
  return Request.post(`${BaseApiUrl}/api/WeighingInSaleOut/Post`, params);
};
//编辑
export const editWeighingInSaleOut = (params) => {
  return Request.post(`${BaseApiUrl}/api/WeighingInSaleOut/Put`, params);
};
//完成
export const completeWeighingInSaleOut = (params) => {
  return Request.post(`${BaseApiUrl}/api/WeighingInSaleOut/Complete`, params);
};
//作废
export const cancelWeighingInSaleOut = (params) => {
  return Request.post(`${BaseApiUrl}/api/WeighingInSaleOut/Cancel`, params);
};
//审核
export const verifyWeighingInSaleOut = (params) => {
  return Request.post(`${BaseApiUrl}/api/WeighingInSaleOut/Verify`, params);
};
//取消审核
export const outVerifyWeighingInSaleOut = (params) => {
  return Request.post(`${BaseApiUrl}/api/WeighingInSaleOut/OutVerify`, params);
};
//入库
export const reciveWhWeighingInSaleOut = (params) => {
  return Request.post(`${BaseApiUrl}/api/WeighingInSaleOut/ReciveWh`, params);
};
//取消入库
export const outReciveWhWeighingInSaleOut = (params) => {
  return Request.post(`${BaseApiUrl}/api/WeighingInSaleOut/OutReciveWh`, params);
};
//批量删除
export const batchDeleteWeighingInSaleOut = (params) => {
  return Request.post(`${BaseApiUrl}/api/WeighingInSaleOut/BatchDelete`, params);
};
// export const batchDeleteWeighingInSaleOut = (params) => {
//   return Request.delete(`${BaseApiUrl}/api/WeighingInSaleOut/BatchDelete`, {
//     data: params,
//     headers: {
//       "Content-Type": "application/json-patch+json",
//     },
//   });
// };

// 获取进料过磅基础数据
export const getWeighingInSaleOutBaseData = () => {
  return Request.get(`${BaseApiUrl}/api/WeighingInSaleOut/GetWeighingInSaleOutBaseData`);
};
//获取历史车牌详情
export const getLicense = (params) => {
  return Request.get(`${BaseApiUrl}/api/Command/GetSaleLicense`, { params: params });
};


//获取打印详情
export const getPrintContent = (params) => {
  return Request.get(`${BaseApiUrl}/api/WeighingInSaleOut/Print`, { params: params });
};
// 获取最后一次过磅单记录
export const getLastWeighingInSaleOut = (params) => {
  return Request.get(`${BaseApiUrl}/api/WeighingInSaleOut/GetLastWeighingInSaleOut`, { params: params });
};
//自动 过皮-打印-完成-入库
export const printCompleteRecive = (params) => {
  return Request.post(`${BaseApiUrl}/api/WeighingInSaleOut/PrintCompleteRecive`, params);
};

// 销售过磅-导出
export const DownWeighingSaleOutHistry = (params, title) => {
  return getExportExcel(`${BaseApiUrl}/api/Command/DownWeighingSaleOutHistry`, params, title);
};